import Transfer from "../models/Transfer"
export const TransferMixin = {
  data() {
    return {
      transfer: this.initialize()
    }
  },
  methods: {
    initialize() {
      return new Transfer({
            user_id: undefined,
            user: {
              name: undefined
            },
            origin_amount: 0,
            from_currency: 'NZD',
            dest_amount: 0,
            to_currency: 'RLS',
            rate: 0,
            service_fee: 0,
            referral_earnings: 0,
            reason: undefined,
            reason_text: '',
            bank_account_id: undefined,
            status: 'awaiting',
            created_at: undefined,
            rebit_account_id: 0,
            recipients: [],
            recipient: {
              name: undefined,
              bank: undefined,
              label1: undefined,
              account_number: undefined
            },
            notify: true,
            bypass: true,
            notes: null
        })
    }
  }
}
